import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import OENumberInput from '../../controls/oe-number-input';
import {OEObjectModelValueTypes, OEObjectModelValueEditHelper, OEObjectModelValueEditDecls} from '../oe-object-model-value-edit-model';
import OEObjectModelValueCell from './oe-object-model-value-cell';
import OEToolbox from '../../../../lib/tools/oe-toolbox';

export default class OEObjectModelVecValueCell extends React.PureComponent {

    constructor(props) {
        super(props);

        this.spec = this.getSpec();

        this.state = {
            spec: clone(this.spec)
        };

        this.onChange = this.onChange.bind(this);
    }

    getSpec(props)   {
        props = props || this.props;

        const isInteger = props.type === OEObjectModelValueTypes.vec2i || props.type === OEObjectModelValueTypes.vec3i;
        const size = props.type === OEObjectModelValueTypes.vec2 || props.type === OEObjectModelValueTypes.vec2i ? 2 : 3;

        const def = props.allowPartialUndefined ? undefined : 0;

        const defaultValue = {x: def, y: def};
        if(size > 2)    defaultValue.z = def;

        return {
            isInteger: isInteger,
            size: size,
            defaultValue: defaultValue
        };
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.type !== this.props.type || nextProps.allowPartialUndefined !== this.props.allowPartialUndefined) {
            this.spec = this.getSpec(nextProps);
            this.setState({spec: clone(this.spec)});
        }
    }

    constrain(value, forceAllowUndefined, props)    {
        props = props || this.props;
        if(forceAllowUndefined) value = value !== undefined ? clone(value) : (props.allowUndefined ? undefined : clone(this.spec.defaultValue));
        if(value === undefined || props.allowUndefined || !forceAllowUndefined)  return value;
        
        if(value.x === undefined)   value.x = this.spec.defaultValue.x;
        if(value.y === undefined)   value.y = this.spec.defaultValue.y;
        if(this.spec.size >= 3 && value.z === undefined)   value.z = this.spec.defaultValue.z;
        return value;
    }

    getLabel(axis)  {
        const defaultLabel = {x: 'x:', y: 'y:', z: 'z:'};
        return this.props.labels && this.props.labels[axis] ? this.props.labels[axis] : defaultLabel[axis];
    }

    render()    {
        return (
            <OEObjectModelValueCell {...this.props}>
                <span className="label">{this.getLabel('x')}</span>
                <OENumberInput
                    disabled={this.props.disabled}
                    allowUndefined={this.props.allowPartialUndefined}
                    deferMinMaxConstraint={this.props.deferMinMaxConstraint}
                    min={this.props.min}
                    max={this.props.max}
                    step={this.state.isInteger ? 1 : this.props.step}
                    value={this.props.value != undefined ? this.props.value.x : undefined}
                    onChange={this.onChange}
                    userData="x"
                />
                <span className="label">{this.getLabel('y')}</span>
                <OENumberInput
                    disabled={this.props.disabled}
                    allowUndefined={this.props.allowPartialUndefined}
                    deferMinMaxConstraint={this.props.deferMinMaxConstraint}
                    min={this.props.min}
                    max={this.props.max}
                    step={this.state.isInteger ? 1 : this.props.step}
                    value={this.props.value != undefined ? this.props.value.y : undefined}
                    onChange={this.onChange}
                    userData="y"
                />
                {this.state.spec.size < 3 ? null :
                    <React.Fragment>
                        <span className="label">{this.getLabel('z')}</span>
                        <OENumberInput
                            disabled={this.props.disabled}
                            allowUndefined={this.props.allowPartialUndefined}
                            deferMinMaxConstraint={this.props.deferMinMaxConstraint}
                            min={this.props.min}
                            max={this.props.max}
                            step={this.state.isInteger ? 1 : this.props.step}
                            value={this.props.value != undefined ? this.props.value.z : undefined}
                            onChange={this.onChange}
                            userData="z"
                        />
                    </React.Fragment>
                }
            </OEObjectModelValueCell>
        );
    }

    onChange(sender, value)    {
        let newValue = this.props.value === undefined ? (!this.props.allowUndefined || this.props.allowPartialUndefined || value !== undefined ? clone(this.spec.defaultValue) : undefined) : clone(this.props.value);
        if(newValue !== undefined)   newValue[sender.props.userData] = value;
        newValue = this.constrain(newValue, true);
        if(OEToolbox.shallowEqual(newValue, this.props.value))  return;
        if(this.props.onChange)   this.props.onChange(this, this.props.name, newValue);
    }
};

OEObjectModelVecValueCell.defaultProps = Object.assign({
    disabled:                   false,
    allowUndefined:             true,
    deferMinMaxConstraint:      true,
    allowPartialUndefined:      false,
}, OEObjectModelValueCell.defaultProps);

OEObjectModelVecValueCell.propTypes = Object.assign({
    disabled:                   PropTypes.bool,
    allowUndefined:             PropTypes.bool,
    deferMinMaxConstraint:      PropTypes.bool,
    allowPartialUndefined:      PropTypes.bool,
    min:                        PropTypes.number,
    max:                        PropTypes.number,
    step:                       PropTypes.number,
    value:                      PropTypes.object,
    labels:                     OEObjectModelValueEditDecls.vecValueCellLabels
}, OEObjectModelValueCell.propTypes);